/**
 * Creates a new tooltip config.
 * Call this once for every `InfoTooltip` you want to show.
 * You may not reuse the returned config across multiple tooltips.
 */
export function createTooltip(): TooltipConfig {
	return new TooltipConfig();
}

/**
 * Don't use directly, use {@link createTooltip} instead.
 */
export class TooltipConfig {
	private static _applicationId = Math.random().toString(36).substring(2, 10);
	private static _nextId = 1;

	// we need to implement this ourselves, because `useId()` requires the component context
	private readonly _elementId = `tooltip-${TooltipConfig._applicationId}-${this.generateId()}`;

	private generateId(): number {
		return TooltipConfig._nextId++;
	}

	/**
	 * Returns the element ID of the tooltip bubble.
	 * Use the elementId to set an `aria-describedby` attribute
	 * on the element containing the text being described by the
	 * tooltip.
	 */
	get elementId(): string {
		return this._elementId;
	}
}
